export const SET_LEADS = 'SET_LEADS';
export const UPDATE_LEAD = 'UPDATE_LEAD';

export const SHOP_TYPE_LABELS = {
  1: 'Restaurant',
  2: 'Grocery',
  3: 'Service',
};
